import React from 'react';
import { Checkbox } from 'material-ui';
import PropTypes from 'prop-types';
import { PORT_WAREHOUSE_TYPES } from 'constants/ports';
import './Warehouses.scss';

const WarehousesView = ({ values }) => (
    <div className="warehouses-block">
        <div className="warehouses-grid">
            {PORT_WAREHOUSE_TYPES.map(({ name, label }) => (
                <div key={name} className="warehouse-item">
                    <Checkbox
                        checked={values[name] || false}
                        label={label}
                        disabled
                    />
                </div>
            ))}
        </div>
    </div>
);

WarehousesView.propTypes = {
    values: PropTypes.object.isRequired,
};

export default WarehousesView;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Warehouses/WarehousesView.jsx